<script>
    let min = 1;
    let max = 100;

    let deactivateStepDown = 0;
    let deactivateStepUp = 0;

    export let quantity = 1;

    function setStepper() {
        if( quantity <= min ){
            quantity = min;
            deactivateStepDown = 1;
            deactivateStepUp = 0;
        }
        else if ( quantity >= max ) {
            quantity = max;
            deactivateStepDown = 0;
            deactivateStepUp = 1;
        }
        else{
            deactivateStepDown = 0;
            deactivateStepUp = 0;
        }
    }

    function stepDown() {
        if( quantity > min ){
            quantity--;
        }
        setStepper();
    }

    function stepUp() {
        if( quantity < max ){
            quantity++;
        }
        setStepper();
    }

    setStepper();
</script>

<style>
    .product__quantity-stepdown, .product__quantity-stepup {
        width: 2.5rem;
        height: 2.5rem;
        display: inline-block;
        border-radius: 2rem;
        line-height: 2.9rem;
        text-align: center;
        vertical-align: middle;
        box-shadow: 0px 0px 5px 0px rgba(221,221,221,1);
    }

    .product__quantity-stepdown:active, .product__quantity-stepup:active {
        background-color: #FFFF00;
    }

    .inactive {
        background-color: #EEEEEE!important;
        fill: #BBBBBB;
        box-shadow: none;
    }

    .product__quantity-value {
        display: inline-block;
        width: 2rem;
        vertical-align: middle;
        text-align: center;
        border: none;
        font-size: 1.2rem;
        font-weight: 500;
    }
</style>

<div>
    <span>Qty. </span>
    <span
        class='product__quantity-stepdown {deactivateStepDown ? 'inactive' : ""}'
        on:click={stepDown}
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height='1rem'><path d="M492 236H20c-11.046 0-20 8.954-20 20s8.954 20 20 20h472c11.046 0 20-8.954 20-20s-8.954-20-20-20z"/></svg>
    </span>
    <span class="product__quantity-value">{quantity}</span>
    <span
        class='product__quantity-stepup {deactivateStepUp ? 'inactive' : ""}'
        on:click={stepUp}
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height='1rem'><path d="M492 236H276V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v216H20c-11.046 0-20 8.954-20 20s8.954 20 20 20h216v216c0 11.046 8.954 20 20 20s20-8.954 20-20V276h216c11.046 0 20-8.954 20-20s-8.954-20-20-20z"/></svg>
    </span>
</div>
